// extracted by mini-css-extract-plugin
export default {"nuevo":"CodigosPromocionales_nuevo__3CTGK"};